export enum DefinedReportParameterEnum {
	UserId = "REPORT_PARAMETER_USER_ID",
	StudyId = "REPORT_PARAMETER_STUDY_ID",
}